import { render, staticRenderFns } from "./NcrDashboardDetail.vue?vue&type=template&id=747556a8&"
import script from "./NcrDashboardDetail.vue?vue&type=script&lang=js&"
export * from "./NcrDashboardDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports